import storage from '@/utils/Storage'
import { JIKE_SOCKET_HOST } from '@/utils/request/host'
import { Manager } from 'socket.io-client'

export const socketManager = new Manager(`${JIKE_SOCKET_HOST}`, {
	transportOptions: {
		polling: {
			extraHeaders: {
				get 'x-jike-access-token'() {
					return storage.auth.token
				},
			},
		},
	},
})

socketManager.on('error', () => {
	// 禁用错误日志输出到控制台
})

export const notificationSocket = socketManager.socket('/notification')
export default socketManager
